<template>
  <div v-for="totalizador in visibleCards" :key="totalizador.id" class="column is-narrow is-6-touch is-12-mobile">
    <div class="is-relative">
      <TrfGlobalLoader type="overlay" :id="`loading-card-${totalizador.tipo}`" class="is-hidden" />
      <CardDashboard
        class="is-clickable"
        :id="`card-${totalizador.nome.split(' ').join('-').toLowerCase()}`"
        :nome="totalizador.nome"
        :quantidade="totalizador.quantidade"
        :bg-color="totalizador.cor"
        :icone="totalizador.icone"
        :isLoading="totalizador.isLoading"
        @click="totalizador.acao"
      />
    </div>
  </div>
</template>

<script>
import CardDashboard from "../../../../components/CardDashboard";
import TrfGlobalLoader from "../../../../components/GlobalLoader";

export default {
  name: "TrfDashboardTotalizadoresCards",
  components: {
    TrfGlobalLoader,
    CardDashboard,
  },
  props: {
    totalizadores : {
      type: Object,
      required: true
    }
  },
  computed: {
    visibleCards() {
      if (!this.totalizadores) return [];

      const visibleList = this.totalizadores.filter((totalizador) => totalizador.isCardSempreVisivel == true);
      return visibleList
    }
  }
};
</script>
<style lang="scss" scoped>
.columns.is-2 > .column {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.card {
  min-width: 178px;
}
</style>
